/**
 * @module FE-CU43_緊急連絡先設定画面-同居家族情報_コンポーネント
 */

export function relationship(vm) {
  return [
    {
      value: null,
      text: vm.$vuetify.lang.t('$vuetify.コード.同居家族続柄.未選択'),
    },
    {
      value: 0,
      text: vm.$vuetify.lang.t('$vuetify.コード.同居家族続柄.本人'),
    },
    {
      value: 1,
      text: vm.$vuetify.lang.t('$vuetify.コード.同居家族続柄.夫'),
    },
    {
      value: 2,
      text: vm.$vuetify.lang.t('$vuetify.コード.同居家族続柄.妻'),
    },
    {
      value: 3,
      text: vm.$vuetify.lang.t('$vuetify.コード.同居家族続柄.子'),
    },
    {
      value: 4,
      text: vm.$vuetify.lang.t('$vuetify.コード.同居家族続柄.孫'),
    },
    {
      value: 5,
      text: vm.$vuetify.lang.t('$vuetify.コード.同居家族続柄.父'),
    },
    {
      value: 6,
      text: vm.$vuetify.lang.t('$vuetify.コード.同居家族続柄.母'),
    },
    {
      value: 7,
      text: vm.$vuetify.lang.t('$vuetify.コード.同居家族続柄.兄'),
    },
    {
      value: 8,
      text: vm.$vuetify.lang.t('$vuetify.コード.同居家族続柄.姉'),
    },
    {
      value: 9,
      text: vm.$vuetify.lang.t('$vuetify.コード.同居家族続柄.弟'),
    },
    {
      value: 10,
      text: vm.$vuetify.lang.t('$vuetify.コード.同居家族続柄.妹'),
    },
    {
      value: 11,
      text: vm.$vuetify.lang.t('$vuetify.コード.同居家族続柄.祖父'),
    },
    {
      value: 12,
      text: vm.$vuetify.lang.t('$vuetify.コード.同居家族続柄.祖母'),
    },
    {
      value: 99,
      text: vm.$vuetify.lang.t('$vuetify.コード.同居家族続柄.その他'),
    },
  ];
}
